import { MapPinIcon, LinkIcon } from '@heroicons/react/24/outline';
import { AppEventDetail } from '../../types/event';
import Card from '../ui/Card';

interface EventDetailsProps {
  event: AppEventDetail;
}

export default function EventDetails({ event }: EventDetailsProps) {
  if (!event.venue && !event.websiteUrl && !event.meetingUrl && !event.evaluationUrl) {
    return null;
  }

  return (
    <Card className="mb-8">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Event Details</h2>
      <div className="space-y-4">
        {event.venue && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-2">Location</h3>
            <div className="flex items-start gap-2">
              <MapPinIcon className="h-5 w-5 text-gray-400 mt-0.5" />
              <span className="text-gray-700">{event.venue}</span>
            </div>
          </div>
        )}
        {event.websiteUrl && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-2">Event Website</h3>
            <a
              href={event.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary-dark text-sm flex items-center gap-1"
            >
              <LinkIcon className="h-4 w-4" />
              Visit Event Website
            </a>
          </div>
        )}
        {event.meetingUrl && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-2">Meeting link</h3>
            <a
              href={event.meetingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary-dark text-sm flex items-center gap-1"
            >
              <LinkIcon className="h-4 w-4" />
              Open meeting link
            </a>
          </div>
        )}
        {event.evaluationUrl && (
          <div>
            <h3 className="text-sm font-medium text-gray-700 mb-2">Evaluation</h3>
            <a
              href={event.evaluationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-primary-dark text-sm flex items-center gap-1"
            >
              <LinkIcon className="h-4 w-4" />
              Open evaluation
            </a>
          </div>
        )}
      </div>
    </Card>
  );
}
